app.controller("ProductController", [
  "$scope",
  "$http",
  "Config",
  "$timeout",
  "product",
  "cart",
  "helper",
  "toaster",
  "$window",

  function (
    $scope,
    $http,
    Config,
    $timeout,
    product,
    cart,
    helper,
    toaster,
    $window
  ) {
    $scope.cartPickers = {
      pad: null,
      bow: null,
    };
    $scope.relProduct = {};
    $scope.related = [];
    $scope.frequent = [];
    $scope.base_url = Config.base_url;
    $http.defaults.headers.common.authorization = Config.api_key;
    $scope.reviews = [];
    $scope.productService = product;
    $scope.product;
    $scope.reviews = [];
    $scope.reviewLimit = 10;
    $scope.cartService = cart;
    $scope.cart = cart.getCart();
    $scope.addonProduct = [null, null, null, null];

    $scope.init = function () {
      $scope.product = $window.product;
      $scope.related = $window.related;
      $scope.frequent = $window.frequent;
      $scope.relProduct = $window.relProduct;
      $scope.cartPickers = $window.cartPickers;
      $scope.product.qty = 1;
      //$scope.getRelatedProducts();
      $scope.getRelatedReviews();

      $timeout(function () {
        $scope.initOwlRelatedProductsSlider();
        $("#preloader_container").remove();
      }, 100);
      //$scope.getExtras();
      if ($scope.product.canonical_category_slug == null) {
        $http({
          method: "GET",
          url:
            Config.api_url +
            "product/canonical?brand=chair-hire&product-slug=" +
            $scope.product.product_slug,
          headers: {
            authorization: Config.api_key,
          },
        }).then(
          function (response) {
            $scope.product.canonical_category_slug = response.data.canonical.split("/")[0];
          },
          function (response) {
            console.log(response);
          }
        );
      }
    };

    $scope.incQty = function (productID) {
      var qty = Math.abs(
        parseInt(
          angular
            .element("#cart_controls_" + productID)
            .find(".product_quantity")
            .val()
        )
      );
      qty++;
      $(".cart_controls_" + productID).each(function () {
        $(this).find(".product_quantity").val(qty);
      });
      $scope.changeQty(productID, null);
    };

    $scope.changeQty = function (productID, $event) {
      if ($event) {
        qty = $event.target.value;
        if (!cart.qtyValidation(qty)) {
          $("input[name*='quantity_" + productID + "']").addClass("error");
          $(".help-" + productID).show();
          $(".cart-add-" + productID).attr("disabled", "disabled");
        } else {
          $("input[name*='quantity_" + productID + "']").removeClass("error");
          $(".help-" + productID).hide();
          $(".cart-add-" + productID).removeAttr("disabled");
        }
      }
    };

    $scope.gotoReviews = function () {
      $(".reviews_tab").find("a")[0].click();
      $("html,body").animate({
        scrollTop: $(".nav").offset().top,
      });
    };

    $scope.incReviews = function ($event) {
      $event.preventDefault();
      $scope.reviewLimit += 3;
      //check if all reviews loaded then hide btn
      $(".grid").isotope("destroy");

      setTimeout(function () {
        $(".grid").isotope({
          // options
          itemSelector: ".grid-item",
          layoutMode: "masonry",
        });
      }, 50);
    };

    $scope.getRelatedReviews = function () {
      productId = $scope.product.product_id;
      $scope.productService.getRelatedReviews(productId).then(
        function (response) {
          $scope.reviews = response.data;
        },
        function (response) {
          console.log(response);
        }
      );
    };

    // $scope.getRelatedProducts = function(){

    // width = 300;
    // height = 300;
    // productId = $scope.product.product_id;
    // limit = 8;

    // $scope.productService.getRelatedProducts(productId, width, height, limit).then(function(response) {
    // 	   	$scope.relatedProducts = response.data;
    // 	   	$timeout(function () {
    // 		    $scope.initOwlRelatedProductsSlider();
    // 		    $('#preloader_container').remove();
    // 		}, 100);
    // 	  }, function(response) {
    // 	    console.log(response);
    // 	 });
    // }

    // $scope.getExtras = function(){
    // 	$scope.productService.getExtras().then(function(response) {
    //    	$scope.extras = response.data;
    //   }, function(response) {
    //     console.log(response);
    //   });
    // }

    $scope.initOwlRelatedProductsSlider = function () {
      var isMulti =
        parseInt($(".related_upsell").find(".item").length) > 1 ? true : false;

      $(".related_upsell").owlCarousel({
        responsive: {
          0: {
            items: 2,
          },
          480: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1200: {
            items: 4,
          },
        },
        navigation: true,
        dots: isMulti,
        slideSpeed: 300,
        paginationSpeed: 400,
        loop: false,
      });
    };

    $scope.cartAdd = function (sectionID, quoteType) {
      if (typeof sectionID == "undefined") {
        sectionID = 4;
      }

      $http({
        method: "POST",
        url:
          Config.api_url +
          "counter?section_id=" +
          sectionID +
          "&brand-key=" +
          Config.brand_key,
        headers: {
          authorization: Config.api_key,
        },
      });

      product = $scope.product;
      localStorage.setItem("product", JSON.stringify($scope.product));
      bow = product.bow_color_option == "yes" ? "yes" : null;
      pad = product.pad_color_option == "yes" ? "yes" : null;
      if (bow) {
        //show bow color pickers
        $("#add_to_cart").hide();
        $("#product_bows").show();
      } else if (pad) {
        //show pad color pickers
        $("#add_to_cart").hide();
        $("#product_pads").show();
      } else {
        //add product to cart
        $scope.addonProduct.forEach(function (addon) {
          if (addon) {
            cart.add(addon, product.qty, null, null, null);
          }
        });
        qty = parseInt(product.qty);
        $scope.addToCartHandler(product, qty, bow, pad, null, quoteType);
      }
    };

    $scope.addToCartWithExtra = function (bow, pad, color, quoteType) {
      $scope.addToCartHandler(
        $scope.product,
        product.qty,
        bow,
        pad,
        color,
        quoteType
      );
      $scope.cartPickers.bow = null;
      $scope.cartPickers.pad = null;
      $scope.addonProduct.forEach(function (addon) {
        if (addon) {
          cart.add(addon, product.qty, null, null, null);
        }
      });

      $scope.hideProductExtras();
    };

    $scope.addToCartHandler = function (
      product,
      qty,
      bow,
      pad,
      color,
      quoteType
    ) {
      product.qty = 1;
      cart.add(product, qty, bow, pad, color);
      if (quoteType == "hire") {
        $("#addToCartModal").modal("show");
        helper.hideTransLoader();
      } else {
        $scope.$on("cartUpdated", function () {
          var origin = new URL(window.location.href).origin;
          window.location.href = origin + "/checkout/details/buy";
        });
      }
    };

    $scope.addToCartHandlerProduct = function (
      product,
      qty,
      bow,
      pad,
      color,
      quoteType
    ) {
      qty = $("input[name*='quantity_" + product.product_id + "']").val();
      $("input[name*='quantity_" + product.product_id + "']").val(1);
      cart.add(product, qty, bow, pad, color);

      if (quoteType == "hire") {
        $("#addToCartModal").modal("show");
        helper.hideTransLoader();
      } else {
        $scope.$on("cartUpdated", function () {
          var origin = new URL(window.location.href).origin;
          window.location.href = origin + "/checkout/details/buy";
        });
      }
    };

    $scope.hideProductExtras = function () {
      $("#add_to_cart").show();
      $("#product_bows").hide();
      $("#product_pads").hide();
      $("#product_bows").find("select").val("");
      $("#product_pads").find("select").val("");
    };

    $scope.changeProductQty = function (productID, $event) {
      if ($event) {
        qty = $event.target.value;
        if (!cart.qtyValidation(qty)) {
          $("input[name*='quantity_" + productID + "']").addClass("error");
          $(".help-" + productID).show();
          $(".cart-add-" + productID).attr("disabled", "disabled");
        } else {
          $("input[name*='quantity_" + productID + "']").removeClass("error");
          $(".help-" + productID).hide();
          $(".cart-add-" + productID).removeAttr("disabled");
        }
      }
    };

    $scope.lowestPrice = function (product, discount) {
      //check if there is price breaks
      if (product.price_breaks.length > 0) {
        //if yes then get the lowest one
        price = Object.values(product.price_breaks).reverse()[0].price;
        console.log(price);
        //if no then return the normal price
        if (discount) {
          console.log(product.special_discount);
          return (100 - parseFloat(product.special_discount)) * price;
        } else {
          return price;
        }
      } else {
        //if no then return the normal price
        if (discount) {
          return product.discounted_price;
        } else {
          return product.price;
        }
      }
    };

    $scope.addonHandler = function (product, index) {
      $scope.addonProduct[index] = product;
    };

    /* ************************Products********************** */

    $scope.cartAddProducts = function (
      productIdx,
      productID,
      sectionID,
      quoteType
    ) {
      if (typeof sectionID == "undefined") {
        sectionID = 4;
      }

      $http({
        method: "POST",
        url:
          Config.api_url +
          "counter?section_id=" +
          sectionID +
          "&brand-key=" +
          Config.brand_key,
        headers: {
          authorization: Config.api_key,
        },
      });

      qty = $("input[name*='quantity_" + productID + "']").val();
      if (isNaN(qty) || Number(qty) <= 0) {
        return;
      }
      qty = qty || 1;

      if (sectionID === 3) {
        //checking the section id which defines the difference between the frequent products and related
        bow =
          $scope.related[productIdx].bow_color_option == "yes" ? "yes" : null;
        pad =
          $scope.related[productIdx].pad_color_option == "yes" ? "yes" : null;
        relProduct = $scope.related[productIdx];
      } else {
        bow =
          $scope.frequent[productIdx].bow_color_option == "yes" ? "yes" : null;
        pad =
          $scope.frequent[productIdx].pad_color_option == "yes" ? "yes" : null;
        relProduct = $scope.frequent[productIdx];
      }
      localStorage.setItem("product", JSON.stringify(relProduct));
      if (bow) {
        //show bow color pickers
        $("#add_to_cart_" + sectionID + "_" + productIdx).hide();
        $("#product_bows_" + sectionID + "_" + productIdx).show();
      } else if (pad) {
        //show pad color pickers
        $("#add_to_cart_" + sectionID + "_" + productIdx).hide();
        $("#product_pads_" + sectionID + "_" + productIdx).show();
      } else {
        //add product to cart
        $scope.addToCartHandler(relProduct, qty, bow, pad, null, quoteType);
      }
    };

    $scope.changeProductQtyProducts = function (productID, $event) {
      if ($event) {
        qty = $event.target.value;
        if (!cart.qtyValidation(qty)) {
          $("input[name*='quantity_" + productID + "']").addClass("error");
          $(".help-" + productID).show();
          $(".cart-add-" + productID).attr("disabled", "disabled");
        } else {
          $("input[name*='quantity_" + productID + "']").removeClass("error");
          $(".help-" + productID).hide();
          $(".cart-add-" + productID).removeAttr("disabled");
        }
      }
    };

    $scope.addToCartWithExtraProduct = function (
      sectionID,
      idx,
      bow,
      pad,
      color,
      quoteType
    ) {
      //   if (sectionID === 3) {
      //     $scope.addToCartHandlerProduct(relProduct, sectionID, bow, pad, color);
      //     $scope.cartPickers.bow = null;
      //     $scope.cartPickers.pad = null;
      //     $scope.hideProductExtrasNew(sectionID, idx);
      //   } else {
      //     $scope.addToCartHandlerProduct(relProduct, sectionID, bow, pad, color);
      //     $scope.cartPickers.bow = null;
      //     $scope.cartPickers.pad = null;
      //     $scope.hideProductExtrasNew(sectionID, idx);
      //   }
      $scope.addToCartHandlerProduct(
        relProduct,
        sectionID,
        bow,
        pad,
        color,
        quoteType
      );
      $scope.cartPickers.bow = null;
      $scope.cartPickers.pad = null;
      $scope.hideProductExtrasNew(sectionID, idx);
    };

    $scope.addToCartHandlerProduct = function (
      product,
      qty,
      bow,
      pad,
      color,
      quoteType
    ) {
      qty = $("input[name*='quantity_" + product.product_id + "']").val();
      $("input[name*='quantity_" + product.product_id + "']").val(1);
      cart.add(product, qty, bow, pad, color);
      if (quoteType == "hire") {
        $("#addToCartModal").modal("show");
        helper.hideTransLoader();
      } else {
        $scope.$on("cartUpdated", function () {
          var origin = new URL(window.location.href).origin;
          window.location.href = origin + "/checkout/details/buy";
        });
      }
    };

    $scope.hideProductExtrasNew = function (sectionID, idx) {
      $("#add_to_cart_" + sectionID + "_" + idx).show();
      $("#product_bows_" + sectionID + "_" + idx).hide();
      $("#product_pads_" + sectionID + "_" + idx).hide();
      $("#product_bows_" + sectionID + "_" + idx)
        .find("select")
        .val("");
      $("#product_pads_" + sectionID + "_" + idx)
        .find("select")
        .val("");
    };
  },
]);
